import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-edit-roles-popup',
    templateUrl: './edit-roles-popup.component.html',
    styleUrls: ['./edit-roles-popup.component.scss']
})
export class EditRolesPopupComponent implements OnInit {

    @Output() closeDialogEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() saveRolesEvent = new EventEmitter<KeycloakApplicationRolesEnum[]>();

    patientRole = KeycloakApplicationRolesEnum.PATIENT;
    doctorRole = KeycloakApplicationRolesEnum.DOCTOR;
    adminRole = KeycloakApplicationRolesEnum.ADMIN;
    editorRole = KeycloakApplicationRolesEnum.CONTENTEDITOR;

    title: string;
    message: string;
    selectedRoles: KeycloakApplicationRolesEnum[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) selectedRoles, private translateService: TranslateService) {
        this.selectedRoles = selectedRoles;
    }

    ngOnInit(): void {
        this.title = this.translateService.instant('USER_MANAGEMENT.USER_TYPE');
        this.message = this.translateService.instant('USER_MANAGEMENT.NEW_USER_TEXT');
    }

    disabled(): boolean {
        return this.selectedRoles.length < 1;
    }

    toggleRole(role: KeycloakApplicationRolesEnum): void {
        const newArray = [...this.selectedRoles];
        const index = newArray.indexOf(role);
        if (index > -1) {
            newArray.splice(index, 1);
        } else {
            newArray.push(role);
        }
        this.selectedRoles = newArray;
    }

    onKeyUp(event: any, role: KeycloakApplicationRolesEnum): void {
        if (event.key === 'Enter' || event.code === 'Space') {
            this.toggleRole(role);
        }
    }

    onSaveRoles(): void {
        this.saveRolesEvent.emit(this.selectedRoles);
    }

    onCancel(): void {
        this.closeDialogEvent.emit();
    }
}
